import React, { Component } from "react";
import { resetPassword } from "../auth";

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newPassword: "",
            message: "",
            error: ""
        };
    }

    handleChange = event => {
        const lValue = event.target.value;
        this.setState({ newPassword: lValue, error: "", message: "" });
    }

    resetPassword = e => {
        e.preventDefault();
        this.setState({ message: "", error: "" });

        resetPassword({
            newPassword: this.state.newPassword,
            resetPasswordLink: this.props.match.params.resetPasswordToken
        }).then(data => {
            if (data.error) {
                console.log(data.error);
                this.setState({ error: data.error });
            } else {
                console.log(data.message);
                this.setState({ message: data.message, newPassword: "" });
            }
        });
    };

    render() {
        return (
            <div className="container">
                <h2 className="mt-5">Reset your Password</h2>
                <form onSubmit={this.resetPassword}>
                    <div className="form-group mt-5">
                        <input
                            type="password"
                            className="form-control"
                            placeholder="Your new password"
                            value={this.state.newPassword}
                            name="newPassword"
                            onChange={this.handleChange}
                            autoFocus
                        />
                    </div>
                    <button className="btn btn-raised btn-primary">Reset Password</button>
                </form>
                <div className="alert alert-danger" style={{ display: this.state.error ? "block" : "none" }}>
                    {this.state.error}
                </div>
                <div className="alert alert-success" style={{ display: this.state.message ? "block" : "none" }}>
                    {this.state.message}
                </div>
            </div>
        );
    }
}

export default ResetPassword;